import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './HelpComponent.css';
import { Link } from 'react-router-dom';
import BackButtonComponent from "../backButtonComponent/BackButtonComponent";

class HelpComponent extends Component {
    render() {
        return (
            <div className='help-container'>
                {this.renderUnauthorizedInfo()}
            </div>
        );
    }

    renderUnauthorizedInfo = () => {
        if (!this.props.isAuthorised) {
            return (
                <div className="help-unauthorized-info-container">
                    <BackButtonComponent path='/login' label={_.get(this.props.translation, 'login.back_to_login_button')}/>
                    <h4 className="text-center">{_.get(this.props.translation, 'help.questions_and_answers_label')}</h4>
                    <ul className="help-unauthorized-info-list">
                        <li>
                            <h5>{_.get(this.props.translation, 'help.question_activation_email')}</h5>
                            <div>
                                {_.get(this.props.translation, 'help.answer_activation_email_start')}
                                <Link to='/resend-activation'>
                                    {_.get(this.props.translation, 'help.answer_activation_email_link')}
                                </Link>
                                {_.get(this.props.translation, 'help.answer_activation_email_end')}
                            </div>
                        </li>
                    </ul>
                </div>
            )
        }
    }
}

HelpComponent.propTypes = {
    isAuthorised: PropTypes.bool,
    translation: PropTypes.object.isRequired
};

export default HelpComponent;



// WEBPACK FOOTER //
// ./src/components/commonComponents/helpComponent/HelpComponent.js